export const GOAL_FILTER_NAMESPACE = 'prodoc@goal:filterRes';
export const USER_ENROLLMENT_NAMESPACE = 'prodoc@user:enrollmentId';
export const USER_TOKEN_NAMESPACE = 'oauth';
export const MENU_ORDER_NAMESPACE = 'prodoc@main:menu';
export const SIDEBAR_STATE_NAMESPACE = 'prodoc@main:sidebar';
export const SIDEBAR_CALENDAR_DATA_NAMESPACE = 'prodoc@main:calendarSidebarData';
